import React from "react";
import { Modal, Box } from "@mui/material";
import ConfirmScheduleJob from "../../../screens/VisitTimelineScreen/JobAction/ConfirmScheduleJob";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  minHeight: 300,
  maxHeight: "80vh",
  overflowY: "auto",
};

const ActionConfirmModal = ({ jobId, open, handleClose }) => {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="confirm-schedule-modal"
      aria-describedby="modal-to-confirm-schedule-job"
    >
      <Box sx={style}>
        <ConfirmScheduleJob JobId={jobId} handleClose={handleClose} />
      </Box>
    </Modal>
  );
};

export default ActionConfirmModal;
